import moment from "moment-timezone";

moment.tz.setDefault("Asia/Almaty")

const convertDateTime = (date) => {
    return new Date(moment(date).format('YYYY-MM-DD HH:mm'))
}

export {convertDateTime}